export function shouldUpdateScroll(prevProps, { location, history }) {
  const { location: prevLocation } = prevProps || { location: null }
  const shouldScroll = !!prevLocation && location.pathname !== prevLocation.pathname
  return shouldScroll
}
